// extracted by mini-css-extract-plugin
export default {"bg":"WK33Jq","scotchT":"e7Fmmq","scotchB":"LpAR6h"};